import { useState } from "react";
import { To, useLocation, useNavigate } from "react-router-dom";
import logo from '../assets/icons/menu_logo.svg';
import homeIcon from '../assets/icons/home.svg'
import activitiesIcon from '../assets/icons/activities.svg';
import transactionsIcon from '../assets/icons/transaction.svg';
import adminMgtIcon from '../assets/icons/admin_mgt.svg';
import bookIcon from '../assets/icons/book.svg';
import profileUsersIcon from '../assets/icons/profile_users.svg';
import logoutIcon from '../assets/icons/logout.svg';
import dashboardActive from '../assets/icons/active/dashboard.svg';
import bookActive from '../assets/icons/active/books.svg';
import transactionsActive from '../assets/icons/active/transactions.svg';
import activitiesActive from '../assets/icons/active/activities.svg';
import usersActive from '../assets/icons/active/users.svg';
import adminActive from '../assets/icons/active/admin.svg';
import Logout from "./Logout";
import "../styles/menu.css";

const Menu = () => {

	const [showLogout, setShowLogout] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();

	const handleMenuItemClick = (route: To) => {
		navigate(route);
	};

	const isActive = (route: string) => {
		return location.pathname === route;
	};


	const getIconSource = (icon: string, activeIcon: string, route: string) => {
    return isActive(route) ? activeIcon : icon;
  };

	return (
		<>
			<div className="menu">
				<div className="menu-body">
					<div className="menu_logo">
						<img src={logo} alt="logo" />
						<h3>Scholarswitch</h3>
					</div>
					<div className="menu_section">
						<div className="main_menu">
							<div
								className={`menu_item ${isActive('/admin/dashboard') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/dashboard')}>
								<img src={getIconSource(homeIcon, dashboardActive, '/admin/dashboard')} alt="dashboard" />
								<span>Dashboard</span>
							</div>

							<div
								className={`menu_item ${isActive('/admin/school-payments') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/school-payments')}>
								<img src={getIconSource(bookIcon, bookActive, '/admin/school-payments')} alt="book" />
								<span>School Payments</span>
							</div>

							<div
								className={`menu_item ${isActive('/admin/transactions') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/transactions')}>
								<img src={getIconSource(transactionsIcon, transactionsActive, '/admin/transactions')} alt="transcation" />
								<span>Transaction</span>
							</div>

							<div
								className={`menu_item ${isActive('/admin/activity-log') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/activity-log')}>
								<img src={getIconSource(activitiesIcon, activitiesActive, '/admin/activity-log')} alt="activities" />
								<span>Activities</span>
							</div>

							<div
								className={`menu_item ${isActive('/admin/user-management') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/user-management')}>
								<img src={getIconSource(profileUsersIcon, usersActive, '/admin/user-management')} alt="users" />
								<span>Users</span>
							</div>

							{/* <div
								className={`menu_item ${isActive('/admin/wallet-management') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/wallet-management')}>
								<img src={getIconSource(walletIcon, walletsActive, '/admin/wallet-management')} alt="wallets" />
								<span>Wallets</span>
							</div> */}

							<div
								className={`menu_item ${isActive('/admin/admin-management') ? 'active' : ''}`}
								onClick={() => handleMenuItemClick('/admin/admin-management')}>
								<img src={getIconSource(adminMgtIcon, adminActive, '/admin/admin-management')} alt="admin" />
								<span>Admin Management</span>
							</div>

							<div className="border mt-4"></div>

						</div>
						<div className="menu_item logout" onClick={() => setShowLogout(true)}>
							<img src={logoutIcon} alt="logout" />
							<span>Logout</span>
						</div>
					</div>
					<Logout showModal={showLogout} closeModal={() => setShowLogout(false)} />
				</div>
			</div>
		</>
	)
};

export default Menu;